import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useInvalidateArchivedDocumentImagesInfiniteQuery } from '../hooks/useArchivedDocumentImagesInfiniteQuery'
import { type DocumentImage } from '../hooks/useFetchArchivedDocumentImages'
import { useUpdateDocumentImageStatusMutation } from '../hooks/useUpdateDocumentImageStatusMutation'

export type UnarchiveButtonProps = {
  documentImage: DocumentImage
}

export const UnarchiveButton = ({ documentImage }: UnarchiveButtonProps) => {
  const { t } = useTranslation()
  const invalidateArchivedDocumentImagesInfiniteQuery =
    useInvalidateArchivedDocumentImagesInfiniteQuery()
  const updateDocumentImageStatusMutation =
    useUpdateDocumentImageStatusMutation({
      onSuccess: () => {
        invalidateArchivedDocumentImagesInfiniteQuery()
      },
    })

  const logEvent = useLogEvent()
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    updateDocumentImageStatusMutation.mutate({
      documentImageId: documentImage.id,
      newStatus: 'active',
    })
    logEvent('Recover saved table and graph')
  }, [documentImage.id, logEvent, updateDocumentImageStatusMutation])

  return (
    <StyledButton
      disabled={
        !documentImage.figureMeta.isUnarchivable ||
        updateDocumentImageStatusMutation.isPending
      }
      fillMode="outline"
      icon="undo"
      onClick={handleClick}
    >
      {t('restore')}
    </StyledButton>
  )
}
